/**
 * Permission Education Dialog
 * Pre-request education screen explaining why permissions are needed
 */

import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import VideocamIcon from '@mui/icons-material/Videocam'
import MicIcon from '@mui/icons-material/Mic'
import InfoIcon from '@mui/icons-material/Info'
import { getEducationContent } from 'src/services/mediaPermissions'

export const PermissionEducationDialog = ({
  open,
  onClose,
  onAllow,
  mediaType = 'both',
  showSkip = false,
}) => {
  const content = getEducationContent(mediaType)

  const getMediaIcon = () => {
    if (mediaType === 'camera') return <VideocamIcon sx={{ fontSize: 60, color: '#514387' }} />
    if (mediaType === 'microphone') return <MicIcon sx={{ fontSize: 60, color: '#514387' }} />
    return (
      <Box sx={{ display: 'flex', gap: 2 }}>
        <VideocamIcon sx={{ fontSize: 60, color: '#514387' }} />
        <MicIcon sx={{ fontSize: 60, color: '#514387' }} />
      </Box>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="permission-education-title"
      aria-describedby="permission-education-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
        },
      }}
    >
      <DialogTitle id="permission-education-title">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            textAlign: 'center',
          }}
        >
          {getMediaIcon()}
          <Typography variant="h5" component="div" fontWeight="bold">
            {content.title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography
            id="permission-education-description"
            variant="body1"
            color="text.secondary"
            textAlign="center"
          >
            {content.subtitle}
          </Typography>

          <List sx={{ py: 0 }}>
            {content.benefits.map((benefit, index) => (
              <ListItem key={index} sx={{ py: 1 }}>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: '#4caf50' }} />
                </ListItemIcon>
                <ListItemText primary={benefit} />
              </ListItem>
            ))}
          </List>

          <Box
            sx={{
              display: 'flex',
              gap: 1,
              p: 2,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              alignItems: 'flex-start',
            }}
          >
            <InfoIcon sx={{ color: '#514387', mt: 0.5, fontSize: 20 }} />
            <Typography variant="body2" color="text.secondary">
              {content.reassurance}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
        {showSkip && (
          <Button
            onClick={onClose}
            variant="outlined"
            color="secondary"
            size="large"
            aria-label="Skip and join without camera or microphone"
          >
            Skip
          </Button>
        )}
        <Button
          onClick={onAllow}
          variant="contained"
          color="primary"
          size="large"
          autoFocus
          sx={{
            backgroundColor: '#514387',
            '&:hover': {
              backgroundColor: '#403266',
            },
            minWidth: 200,
          }}
          aria-label="Allow camera and microphone access"
        >
          Allow Access
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PermissionEducationDialog


















